import { useState, useEffect } from 'react';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { makeStyles } from '@mui/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import Container from '@mui/material/Container';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Button from '@mui/material/Button';
import { findByNumeroBimestre, update, remove } from '../Bimestre/api-bimestre';
import { Link } from 'react-router-dom';
import DeleteIcon from '@mui/icons-material/Delete';
import { confirmAlert } from 'react-confirm-alert';
import { errorMessage } from '../../util/ConfirmAlertUtil';
import Loading from '../UI/Loading';
import TextFieldDate from '../UI/TextFieldDate';
import dayjs from 'dayjs';


const useStyles = makeStyles({
    root: {
        flexGrow: 1,
    },
    title: {
        paddingTop: '20px;',
        margin: '20px'
    },
    paper: {
        textAlign: 'center',
    },
    insereSerie: {
        marginBottom: '30px'
    },
    cursorLink: {
        cursor: 'pointer'
    }
});

const rows = [
    '1º Bimestre',
    '2º Bimestre',
    '3º Bimestre',
    '4º Bimestre'
];

export default function Bimestre() {
    const classes = useStyles();
    const [selectedBimestre, setSelectedBimestre] = useState();
    const [bimestres, setBimestres] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const handleDataInicioChange = (data, index) => {
        let bimestre = bimestres[index];
        bimestre.dataInicio = dayjs(data);
        update(bimestre).then(data => {
            if (data.error) {
                errorMessage(data.message);
                console.log(data);
            } else {
                setBimestres(prevState => (
                    prevState.map(b => {
                        if (b.codigo === bimestres[index].codigo) {
                            return bimestre;
                        } else {
                            return b;
                        }
                    })
                ))
            }
        });
    }

    useEffect(() => {
        handleSelecionarBimestre(0, rows[0]);
    }, []);

    const handleDataFimChange = (data, index) => {
        let bimestre = bimestres[index];
        bimestre.dataFim = dayjs(data);
        update(bimestre).then(data => {
            if (data.error) {
                errorMessage(data.message);
                console.log(data);
            } else {
                setBimestres(prevState => (
                    prevState.map(b => {
                        if (b.codigo === bimestres[index].codigo) {
                            return bimestre;
                        } else {
                            return b;
                        }
                    })
                ))
            }

        });
    }

    const handleSelecionarBimestre = (index, row) => {
        setIsLoading(true);
        findByNumeroBimestre(index + 1).then((data) => {
            if (data.error) {
                console.log(data.error);
            } else {
                setBimestres(data);
                setSelectedBimestre(row);
            }
            setIsLoading(false);
        })
    };

    const handleDelete = (index) => {
        confirmAlert({
            title: 'Alerta',
            message: 'Deseja deletar este bimestre?',
            buttons: [
                {
                    label: 'Sim',
                    onClick: () => {
                        remove(bimestres[index].codigo).then((data) => {
                            if (data) {
                                let content = bimestres.filter((bimestre, i) => i !== index);
                                setBimestres(content);
                            } else {
                                console.log(data.error);
                            }
                        });
                    }
                },
                {
                    label: 'Não',
                    onClick: () => { }
                }
            ]
        });
    };


    return (
        <div className={classes.root}>
            <Grid container spacing={2}>
                <Grid size={4}>
                    <Paper className={classes.paper}>
                        <Typography className={classes.title} variant="h5">
                            Bimestres
                        </Typography>
                        <Container component={Paper}>
                            <Table aria-label="customized table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Nº Bimestre</TableCell>
                                        <TableCell></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {rows.map((row, index) => (
                                        <TableRow key={index}>
                                            <TableCell component="th" scope="row">
                                                {row}
                                            </TableCell>
                                            <TableCell align="right">
                                                <Button onClick={() => { handleSelecionarBimestre(index, row) }}
                                                    variant="contained"
                                                    color="secondary">
                                                    Selecionar
                                                </Button>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Container>

                    </Paper>
                </Grid>
                <Grid size={8}>
                    <Paper className={classes.paper}>
                        <Typography className={classes.title} variant="h5">
                            Bimestres por Série{`${selectedBimestre ? ' - ' + selectedBimestre : ''}`}
                        </Typography>
                        <Link to={"/bimestre-form"}>
                            <Button
                                variant="contained"
                                color="primary"
                                className={classes.insereSerie}>
                                Inserir Série
                            </Button>
                        </Link>
                        {isLoading ? <Loading description={"Carregando Bimestres..."} /> :
                            <Table aria-label="customized table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Série</TableCell>
                                        <TableCell>Data Início</TableCell>
                                        <TableCell>Data Fim</TableCell>
                                        <TableCell>Ações</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {bimestres.map((bimestre, index) => (
                                        <TableRow key={bimestre.codigo}>
                                            <TableCell component="th" scope="row">
                                                {bimestre.serie.descricao}
                                            </TableCell>
                                            <TableCell>
                                                <TextFieldDate
                                                    onChange={(data) => handleDataInicioChange(data, index)}
                                                    value={bimestre.dataInicio ? bimestre.dataInicio : null}
                                                    label="Data Início"
                                                />
                                            </TableCell>
                                            <TableCell>
                                                <TextFieldDate
                                                    onChange={(data) => handleDataFimChange(data, index)}
                                                    value={bimestre.dataFim ? bimestre.dataFim : null}
                                                    label="Data Fim"
                                                />
                                            </TableCell>
                                            <TableCell>
                                                <DeleteIcon
                                                    className={classes.cursorLink}
                                                    onClick={() => { handleDelete(index) }}
                                                    color="secondary" />
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        }

                    </Paper>
                </Grid>
            </Grid>
        </div>
    );
}